import styled from "styled-components";

export const ToggleIconContainer = styled.div`
  cursor: pointer;
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
`;
